import { formatShortcutLabel } from 'utils/key-shortcuts';
import { KeyShortcutBindings } from 'utils/key-shortcuts-types';
import { GridModeToolbarItem } from './grid-mode-toolbar-item';

export function getGridModeToolbarTooltipText<T extends string>(
  item: GridModeToolbarItem<T>,
  isDisabled: boolean,
  disabledTooltip?: string
): string {
  if (isDisabled) return disabledTooltip || item.label;
  return formatShortcutLabel(item.label, item.shortcutKey);
}

export function getGridModeToolbarShortcutBindings<T extends string>(
  items: GridModeToolbarItem<T>[],
  onChange: (mode: T) => void,
  isItemDisabled?: (mode: T) => boolean
): KeyShortcutBindings {
  const bindings: KeyShortcutBindings = {};
  items.forEach((item) => {
    const { shortcutKey } = item;
    if (shortcutKey && !isItemDisabled?.(item.id)) {
      bindings[shortcutKey] = () => onChange(item.id);
    }
  });
  return bindings;
}
